import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../PAcido";
import { plotBackground } from "../../../config/colors";


export default function GasesAConversion() {
  const [sO2, setSO2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [o2, setO2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [razonO2_SO2, setRazonO2_SO2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caudalGas, setCaudalGas] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [masaSO2aPAS, setMasaSO2aPAS] = useState({
    value: [],
    fecha: [],
    estado: [],
  });



  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 5,
    secuencia: 25,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateSO2(data);
    populateO2(data);
    populateRazonO2_SO2(data);
    populaterCaudalGas(data);
    populateMasaSO2aPAS(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateSO2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "SO2 Entrada a Conversión"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setSO2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateO2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "O2 Entrada a Conversión"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setO2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateRazonO2_SO2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Razón O2/SO2 Entrada a Conversión"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setRazonO2_SO2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populaterCaudalGas(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal Gas a Torre Secado"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalGas({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateMasaSO2aPAS(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Masa de SO2 a PAS Teórico"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setMasaSO2aPAS({
      fecha: arrFechas,
      value: arrValues,
    });
  }
  
 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Gases a Conversión"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- SO2 Entrada a Conversión --------------------------------------- */}
            <Chart.Line
              name="SO2 Entrada a Conversión"
              data={sO2.value}
              yAxis={1}
            />
            {/** -------------------------------- O2 Entrada a Conversión --------------------------------------- */}
            <Chart.Line
              name="O2 Entrada a Conversión"
              data={o2.value}
              yAxis={1}
            />
            {/** -------------------------------- Razón O2/SO2 Entrada a Conversión --------------------------------------- */}
            <Chart.Line
              name="Razón O2/SO2 Entrada a Conversión"
              data={razonO2_SO2.value}
              yAxis={1}
            />
            {/** -------------------------------- Caudal Gas a Torre Secado --------------------------------------- */}
            <Chart.Line
              name="Caudal Gas a Torre Secado"
              data={caudalGas.value}
              yAxis={0}
            />
            {/** -------------------------------- Masa de SO2 a PAS Teórico --------------------------------------- */}
            <Chart.Line
              name="Masa de SO2 a PAS Teórico"
              data={masaSO2aPAS.value}
              yAxis={1}
            />
           
            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={sO2.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
            />

            <Chart.YAxis
              labelSuffix=" t/h"
              title="Contenido, % - SO2 a PAS, t/h - R.O2 / SO2, -"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
